import { skipToken } from "@reduxjs/toolkit/query/react";

import {
    dataSourceIdMap,
    lelyDataWarehouseDataSourceIdMap,
    mfpPluginDataSourceIdMap,
} from "features/data-source/data-source-id-map";
import { DataSourceRegistryPath, pathToNameMap } from "features/data-source/data-source-registry";
import { DataSourceName, DataSourceParameterMap } from "features/data-source/data-source.types";
import { toDataSourceParameters } from "features/data-source/useDataSource";
import { GetDataSourceOptionsV1, GetDataSourceOptionsV2 } from "store/services/data-source.service";

/** Convert parameters */

export const convertNullableParametersToStrings = (
    parameters?: Record<string, string | number | boolean | undefined | null>
): Record<string, string | number | boolean> => {
    if (!parameters) return {};

    return Object.fromEntries(Object.entries(parameters).map(([key, value]) => [key, value ?? ""])) as Record<
        string,
        string | number | boolean
    >;
};

/** Prepare arguments for data source fetching. */

export const prepareNewApproachArgs = (
    dataSourcePath: DataSourceRegistryPath,
    parameters?: Record<string, string | number | boolean>,
    options?: { skip?: boolean }
): GetDataSourceOptionsV2 | typeof skipToken => {
    let args: GetDataSourceOptionsV2 | typeof skipToken;
    if (!options?.skip) {
        args = {
            apiVersion: "v2",
            path: dataSourcePath,
            parameters: convertNullableParametersToStrings(parameters),
        };
    } else {
        args = skipToken;
    }

    return args;
};

export const prepareOldApproachArgs = (
    dataSource: DataSourceName,
    parameters?: DataSourceParameterMap,
    options?: { skip?: boolean }
) => {
    const dataSourceId = dataSourceIdMap[dataSource];

    let args: GetDataSourceOptionsV1 | typeof skipToken;
    if (dataSourceId && !options?.skip) {
        args = {
            apiVersion: "v1",
            id: dataSourceId,
            parameters: toDataSourceParameters(parameters),
        };
    } else if (options?.skip) {
        args = skipToken;
    } else {
        console.warn(`Can't call data source with the name ${dataSource}, it's not registered in the data source map`);
        args = skipToken;
    }

    return args;
};

/** Data fetching  */

export const shouldUseJSBE = (dataSource: DataSourceName, hasJSBEDataSourcesEnabled: boolean) => {
    const isPluginKind =
        dataSource && (dataSource in lelyDataWarehouseDataSourceIdMap || dataSource in mfpPluginDataSourceIdMap);
    return hasJSBEDataSourcesEnabled && !isPluginKind;
};

export const shouldUseNewApproach = (
    dataSourcePath: DataSourceRegistryPath,
    hasDataSourcesNewApproachEnabled: boolean
) => {
    const inNewApproachPaths = dataSourcePath in pathToNameMap;
    return hasDataSourcesNewApproachEnabled && inNewApproachPaths;
};
